import { isValueUnset } from '@optic-delight/ui-framework';
import { put } from 'redux-saga/effects';
import ClientActions from '../client/client-actions';

export function* loadAndAlertMsg(error, defaultMsg, useDefaultMsg) {
	yield put({ type: ClientActions.FETCHING_DATA_DONE });
	window.scrollTo(0, 0);
	yield put({
		type: ClientActions.APP_SHOW_ALERT,
		payload: {
			type: 'danger',
			message: useDefaultMsg
				? defaultMsg
				: error &&
				  error.response &&
				  error.response.data &&
				  error.response.data.errors &&
				  error.response.data.errors[0] &&
				  error.response.data.errors[0].errorFields
				? Object.keys(error.response.data.errors[0].errorFields)[0]
				: error.response.data.errors[0].message
				? error.response.data.errors[0].message
				: defaultMsg
		}
	});
}

export function maxChar50(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return value && value.length < 51;
}

export function maxChar250(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return value && value.length < 251;
}

export function maxChar140(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return value && value.length < 141;
}

export function emailValidate(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]{1,255}\.)+[a-zA-Z]{1,63}))$/.test(
		value
	);
}

export function scopeValidate(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return /^(([a-z]{3,20}[:]){1,2}[a-z]{3,20})$/.test(value);
}

export function maxChar100(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return value && value.length < 101;
}

// generates random string
export function generateRandomString() {
	const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let randomString = '';
	for (let i = 0; i < 20; i++) {
		let randomPoz = Math.floor(Math.random() * charSet.length);
		randomString += charSet.substring(randomPoz, randomPoz + 1);
	}
	return randomString;
}

// convert date time to MM/DD/YYYY
export function getFormattedDate(date) {
	let year = date.getFullYear();
	let month = (1 + date.getMonth()).toString();
	month = month.length > 1 ? month : '0' + month;
	let day = date.getDate().toString();
	day = day.length > 1 ? day : '0' + day;
	return month + '/' + day + '/' + year;
}

export function onlyAlphabetsAndDigits(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return /^[A-Za-z0-9]+$/.test(value);
}

export function noWhiteSpaces(value) {
	if (isValueUnset(value)) {
		return true;
	}
	return !/\s/.test(value);
}

// for generating code verfier and code challenge
function dec2hex(dec) {
	return ('0' + dec.toString(16)).substr(-2);
}

export function generateCodeVerifier() {
	let array = new Uint32Array(56 / 2);
	window.crypto.getRandomValues(array);
	return Array.from(array, dec2hex).join('');
}
function sha256(plain) {
	// returns promise ArrayBuffer
	const encoder = new TextEncoder();
	const data = encoder.encode(plain);
	return window.crypto.subtle.digest('SHA-256', data);
}

function base64urlencode(a) {
	let str = '';
	let bytes = new Uint8Array(a);
	let len = bytes.byteLength;
	for (let i = 0; i < len; i++) {
		str += String.fromCharCode(bytes[i]);
	}
	return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function generateCodeChallengeFromVerifier(v) {
	let hashed = await sha256(v);
	return base64urlencode(hashed);
}

export function dynamicSort(property) {
	let sortOrder = 1;
	if (property && property[0] && property[0] === '-') {
		sortOrder = -1;
		property = property.substr(1);
	}
	return function (a, b) {
		let result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
		return result * sortOrder;
	};
}
